import { z } from "zod";
import { TFile, TObjectBase, TApiObjectBase } from "../base";
import { TFirebaseTimestamp } from "../deprecated";
import {
  TUserDisabledEmailNotificationSettings,
  TUserDisabledPushNotificationSettings,
} from "../notifications/user";

export type IProfileImages = z.infer<typeof TProfileImages>;
export const TProfileImages = z.object({
  small: TFile.optional(),
  large: TFile.optional(),
});

export type IRawUser = z.infer<typeof TRawUser>;
export const TRawUser = z
  .object({
    name: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().nullish(),

    hasAuth: z.boolean().optional(),
    isBlocked: z.boolean().optional(),

    chats: z.array(z.string()).optional(),
    companies: z.array(z.string()).optional(),
    properties: z.array(z.string()).optional(),
    favoriteProperties: z.array(z.string()).optional(),
    contractorGroups: z.array(z.string()).optional(),

    disabledEmailNotifications:
      TUserDisabledEmailNotificationSettings.optional(),
    disabledPushNotifications: TUserDisabledPushNotificationSettings.optional(),

    profileImages: TProfileImages.optional(),

    lastLogin: TFirebaseTimestamp.optional(),
    preferredLangCode: z.string().optional(),
  })
  .extend(TObjectBase.shape);

export type IApiUser = z.infer<typeof TApiUser>;
export const TApiUser = z
  .object({
    name: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().nullish(),

    hasAuth: z.boolean().optional(),
    isBlocked: z.boolean().optional(),

    chats: z.array(z.string()).optional(),
    companies: z.array(z.string()).optional(),
    properties: z.array(z.string()).optional(),
    favoriteProperties: z.array(z.string()).optional(),
    contractorGroups: z.array(z.string()).optional(),

    profileImages: TProfileImages.optional(),

    lastLogin: z.coerce.date().optional(),
  })
  .extend(TApiObjectBase.shape);
